// APIs
import MenuApi from '@/api/MenuApi';

// utils.
import router, { asyncRoutes, constantRoutes } from '@/router';
import registryRouteFactory from '@/router/modules/registry';

/**
 * Through meta.role determines whether the current user rights match
 * @param groups
 * @param route
 */
const hasPermission = (groups, route) => {
  if (route.meta && route.meta.groups && route.meta.groups.length) {
    return groups.some((role) => route.meta.groups.includes(role));
  }
  return true;
};

const getPriority = (a) => ((a.meta || {}).priority || 100);

/**
 * Recursively filter asynchronous routing tables to return routing tables
 * that meet user role permissions
 * @param groups
 * @param routes asyncRoutes
 */
export const filterAsyncRoutes = (groups, routes) => {
  const res = [];
  routes.forEach((route) => {
    const tmp = { ...route };
    if (hasPermission(groups, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(groups, tmp.children);
      }
      res.push(tmp);
    }
  });
  return res;
};

const permission = {
  state: {
    routes: [],
    addRoutes: [],
  },

  getters: {
    permissionRoutes: (state) => state.routes,
    addRoutes: (state) => state.addRoutes,
  },

  mutations: {
    SET_ROUTES: (state, routes) => {
      state.addRoutes = routes;
      state.routes = constantRoutes.concat(routes);
    },
  },
  actions: {
    GenerateRoutes: async ({ commit }, user) => {
      const menuApi = new MenuApi();
      const menus = await menuApi.getMenus();
      const routes = [...asyncRoutes];
      menus.forEach((menu) => {
        routes.push(registryRouteFactory(menu));
      });

      const { groups } = user;
      try {
        // console.groupCollapsed(`[vuex.permission] GenerateRoutes [${groups}]`);
        const accessedRoutes = filterAsyncRoutes(groups, routes);

        accessedRoutes.sort((a, b) => {
          const result = getPriority(a) - getPriority(b);
          return result;
        });
        commit('SET_ROUTES', accessedRoutes);
        // Apply selected allowed routes
        accessedRoutes.forEach((route) => router.addRoute(route));
        // console.log('[vuex.permission] accessedRoutes ', constantRoutes);
        // console.groupEnd();
      } catch (err) {
        console.warn('[vuex.permission] GenerateRoutes', err);
      }
    },
  },
};

export default permission;
